import React from 'react';
import { createSvgIcon } from '../helpers/createSvgIcon';
export var CheckIcon = createSvgIcon(React.createElement("path", {
  fill: 'currentColor',
  d: 'M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z'
}), 'Check');